export default {
  projectData: state => state.projectData,
  crmProjectData: state => state.crmProjectData,
  detail: state => state.detail,
  projectTeams: state => state.projectTeam,
  projectListSelect: state => state.projectListSelect,
  projectCustomer: state => state.projectCustomer,
  projectCustomerSelect: state => state.projectCustomerSelect,
  projectContractSelect: state => state.projectContractSelect,
  projectSalesmanSelect: state => state.projectSalesmanSelect,
  projectPackage: state => state.projectPackage,
};
